import React from 'react';
import moment from "moment";
import {Spinner} from "react-bootstrap";
import Countdown from "react-countdown";
import {Navigate} from "react-router-dom";

import Maximum from "assets/images/svg/maximum_number_exceeded_code.svg";
import { useResendEmailToken } from "pages/informations/info.service";


function BlockedEmailPage() {
    const { handleResendEmailCode,isStillValid,routeState ,isLoading,preregisterData} = useResendEmailToken();

    if(!preregisterData) return <Navigate to='/register' />;
    if(isStillValid) return  <Navigate to='/info/link-sent' state={routeState} />;

    return (
        <div className="registration link-send">
            <div className="row">
                <div className="col-lg-8 col-md-12 mx-auto">
                    <div className="row">
                        <div className="col-lg-6 col-md-4">
                            <img className="background" src={Maximum} alt="background" />
                        </div>
                        <div className="col-lg-6 col-md-8">
                            <div className="box-linksend">
                                <h1>SORRY</h1>
                                <p>
                                    sorry <br /> It seems you used the maximum number of times to
                                    send the verification link  code to email "3 times", please try again
                                    after 24 hour
                                </p>
                                {/* @ts-ignore */}
                                <Countdown
                                    key={moment(preregisterData.blockTillDate).toISOString()}
                                    date={moment(preregisterData.blockTillDate).toDate()}
                                    renderer={(p) => (
                                        <button
                                            disabled={isLoading || !p.completed}
                                            onClick={handleResendEmailCode}
                                            className="btn-blue"
                                        >
                                            {isLoading ? <Spinner animation="border" size="sm" /> : null}
                                            {p.completed
                                                ? "Send Again"
                                                : `${p.formatted.hours}:${p.formatted.minutes}:${p.formatted.seconds}`}
                                        </button>
                                    )}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BlockedEmailPage;